
var TableTempaltes={
    'table':'<div class="dataTables_wrapper"></div>',
    'filter_length':'<label>'+_.unescape(window.LANGUAGE['tablemagick.show-entites'])+'</label>',
    'filter_search':'<label>Search:<input type="search" class="" placeholder="" aria-controls="data-table-basic"></label>',
    'display-table':'<div class="card-body card-padding"><ul class="tab-nav"></ul></div><div class="tab-content clearfix"></div>',
    'display-table-tab':'<div class="table-responsive"><div class="table-loading page-loader"><div class="preloader pls-blue"><svg class="pl-circular" viewBox="25 25 50 50"><circle class="plc-path" cx="50" cy="50" r="20"></circle></svg><p>Please wait...</p></div></div><div class="has-no-table-data">NoDataPassHere</div><table class="table table-striped dataTable"><thead><tr></tr></thead><tfoot><tr></tr></tfoot><tbody></tbody></table></div>'
};


window.GlobalManager=new (function(){});
_.extend(window.GlobalManager,Backbone.Events);
window.GlobalManager.on("all", function(){
    console.log("Events ", arguments);
});
window.GLANG={};

Template7.registerHelper('lang', function (key) {
    return _.isUndefined(window.GLANG[key])?(_.isUndefined(window.LANGUAGE[key])?key:window.LANGUAGE[key]):window.GLANG[key];
});

Template7.registerHelper('slimlang', function() {
    var keys = ["label",
        "button-cancel-title","button-edit-title","button-remove-title","button-download-title","button-upload-title","button-confirm-title",
        "button-cancel-label","button-edit-label","button-remove-label","button-download-label","button-upload-label","button-confirm-label"];

    var setof = [];
    for(var ukey in keys) {
        var akey = keys[ukey];
        var key = 'slim.' + akey;
        setof.push('data-'+akey+'="'+(_.isUndefined(window.GLANG[key])?(_.isUndefined(window.LANGUAGE[key])?key:window.LANGUAGE[key]):window.GLANG[key])+'"');
    }
    console.log('setof', setof);
    return setof.join(" ");
});

var TableMagickCancelSortModal =  Backbone.Ribs.View.extend({
    months:null,
    bindings:{

    },
    modal:null,
    initialize:function(modal) {
        this.modal = modal;
        this.modal.modal.css({'z-index': 99999});
        this.modal.modal.find(".modal-lg").removeClass("modal-lg");
        modal.modalOpts.buttons = [
            {
                id:'cancel',
                event:'close',
                style:'btn-default',
                cbs:[this.doApply.bind(this)],
                title:window.LANGUAGE['tablemagick.sort.modal.yes']
            },
            {
                id:'apply',
                event:'',
                cbs:[this.doCancel.bind(this)],
                style:'btn-danger',
                title:window.LANGUAGE['tablemagick.sort.modal.no']
            }
        ];
        modal.renderButtons();
        this.$el.html(Template7.compile(window.LANGUAGE['tablemagick.sort.modal.content'])());

    },
    doCancel: function(){
        this.modal.modalOpts.config.doCancel();
        this.modal.hideDestroy();
    },
    doApply: function() {
        this.modal.modalOpts.config.doApply();
        this.modal.hideDestroy();
    }
});

var TableLoaderCollection=Backbone.Ribs.Collection.extend({
    filters:{},
    cpage:0,
    rlength:0,
    perPage:10,
    url:function(){
        var url=this.baseUrl || window.location.toString();
        var sep = (url.indexOf('?')===-1)?'?':'&';
        var $params=[];
        _.each(this.filters,function(val,key){
            $params.push(['f:'+key,encodeURIComponent(val)].join("="));
        });
        url+=$params.length?sep+$params.join("&"):'';
        return url;
    },
    initialize:function(data,options){
        this.baseUrl=options?options.baseUrl?options.baseUrl:window.location.pathname:window.location.pathname;
    },
    parse:function(resp,options)
    {
        if(resp.error || !resp.items)
        {
            alert("Collection Error: " + resp.msg);
            return {};
        }

        this.rlength=resp.length;
        this.cpage=resp.currentPage;
        this.perPage=resp.perPage;
        this.sorting=resp.sort;

        if(resp.columns) {
            var first=1;
            var cc = [];
            _.each(resp.columns,_.bind(function(column,key){

                var m=new Backbone.Ribs.Model({
                    name:key,
                    bind:column,
                    allow_sort:!_.isObject(column) || !!column.allowsort,
                    sorting:first?first--:0
                });
                cc.push(m);
            },this));
            this.columns.reset(cc);
        }

        if(this.sorting)
        {
            this.trigger("availSort",this.sorting);
        }

        if(resp && resp.sorting) {
            this.trigger("changeCustomSorting",true);
        }else{
            this.trigger("changeCustomSorting",false);
        }

        var items=[];
        _.each(resp.items,function(item,i){
            items[i]=item;
        });
        return items;
    },
    updateSorting:function(ids) {
        $.ajax({
            type: "POST",
            url: this.baseUrl,
            data: {sortIds:ids},
            success: function(resp){
                if(resp.success) {
                    SuccessMessage(resp.message);
                }
            }
        });
    }
});

var TableBaseFilter=Backbone.Ribs.View.extend({
    bindings:{},
    events:{},
    _bindings:{},
    _events:{},
    initialize:function(options)
    {
        this.model.set("complete",false);
        _.extend(this.bindings,this._bindings);
        _.extend(this.events,this._events);
        this.onChangeMe=_.debounce(_.bind(this.onChangeMeD,this),400);
        this.init(options);
    },
    onChangeMeD:function(filter)
    {
        if(!this.model.get("complete"))
            this.model.set("complete",true);
        else
            this.model.collection.triggerChange(filter);
    }
});
var TableLengthFilter=TableBaseFilter.extend({
    className:'dataTables_length',
    bindings:{
        select:{
            value:'model.value'
        }
    },
    init:function(){
        this.$el.html(TableTempaltes.filter_length);
        this.model.on("change",_.bind(function(){
            this.onChangeMe(this.model.attributes);
        },this));
        this.onChangeMe(this.model.attributes);
    }
});
var TableSearchFilter=TableBaseFilter.extend({
    className:'dataTables_filter',
    bindings:{
        input:{
            value:{
                data:'model.value',
                events:'keyup change',
                processor:'search'
            }
        }
    },
    processors: {
        search:{
            get: function (value) {
                return (value==null)?'':value;
            },
            set: function (val) {
                return (val=='')?null:val;
            }
        }
    },
    init:function(){
        this.$el.html(TableTempaltes.filter_search);
        this.model.on("change",_.bind(function(){
            this.onChangeMe(this.model.attributes);
        },this));
        this.onChangeMe(this.model.attributes);
    }
});

var TableFilters=Backbone.Ribs.View.extend({
    bindings:{
        el:{
            collection:{
                col:'col',
                view:function(options){
                    switch(options.model.get("type"))
                    {
                        case "length":
                            return new TableLengthFilter(options);
                        case "search":
                            return new TableSearchFilter(options);
                    }
                }
            }
        }
    },
    initialize:function(){
        this.col=new Backbone.Ribs.Collection();
        this.col.triggerChange=_.bind(function(filter){
            this.col.trigger("FilterChange",filter);
        },this);
        this.col.set([
            new Backbone.Ribs.Model({
                type:'length',
                name:'per_page',
                value:10,
                complete:false
            }),
            new Backbone.Ribs.Model({
                type:'search',
                value:null,
                name:'search',
                complete:false
            })
        ]);
    },
    allComplete:function() {
        for(var i in this.col.models) {
            if (!this.col.models[i].get("complete")) {
                return false;
            }
        }
        return true;
    }
});

var TablePaginatorPage=Backbone.Ribs.View.extend({
    tagName:'a',
    className:'paginate_button ',
    bindings:{
        el:{
            text:'model.name',
            classes:{
                current:'model.active'
            }
        }},
    events:{
        "click":"onClick"
    },
    initialize:function()
    {

        if(this.model.has("dots"))
        {
            this.$el.html("...");
            this.$el.addClass("white");
            this.bindings={};this.preventBindings();
        }
    },
    onClick:function()
    {
        this.model.collection.setPage(this.model.get("id"));
        return false;
    }
});

var TablePaginator=Backbone.Ribs.View.extend({
    tagName:'div',
    bindings:{
        'span':{
            collection:{
                col:'pagesDisplay',
                view:TablePaginatorPage
            }
        },
        '.previous':{
            classes:{
                disabled:'model.isFirst'
            }
        },
        '.next':{
            classes:{
                disabled:'model.isLast'
            }
        },
        '.dataTables_info':{
            text:{
                data:['model.show','model.clength','model.length'],
                processor:function(show,pp,l)
                {
                    var cases = [2, 0, 1, 1, 1, 2];
                    var titles=show.split("::");
                    var s=titles[ (pp%100>4 && pp%100<20)? 2 : cases[(pp%10<5)?pp%10:5] ];
                    return s.replace(/\$1/g,pp).replace(/\$2/g,l);
                }
            }
        },
        '.dataTables_paginate':{
            toggle:{
                data:'model.pages',
                processor:function(pages)
                {
                    return pages>1;
                }
            }
        }
    },
    events:{
        "click .previous":"onPrev",
        "click .next":"onNext"
    },
    initialize:function(options){
        this.dataTable=options.tableData;
        this.model=new Backbone.Ribs.Model({
            perPage:10,
            length:0,
            page:0,
            pages:0,
            show:'Show $1 of $2 items',
            isLast:0,
            isFirst:0
        });
        this.pages=new Backbone.Ribs.Collection();
        this.pagesDisplay=new Backbone.Ribs.Collection();
        if(options.lang && options.lang.show)
        {
            this.model.set("show",options.lang.show);
        }
        this.$el.html('<div class="dataTables_info">test</div><div class="dataTables_paginate paging_simple_numbers"><a class="paginate_button previous"></a><span></span><a class="paginate_button next"></a></div>');
        this.dataTable.on("add reset remove",_.bind(this.updateTable,this));
        this.updateTable();
        this.pages.setPage=_.bind(this.setPage,this);
        this.pagesDisplay.setPage=_.bind(this.setPage,this);
        this.setPage(0);
    },
    updateTable:function()
    {
        this.model.set({
            perPage:this.dataTable.perPage,
            length:this.dataTable.rlength,
            clength:this.dataTable.length,
            page:this.dataTable.cpage,
            pages:Math.ceil(this.dataTable.rlength/this.dataTable.perPage)
        });
        /*var sPages=[];
        for(var i=0;i<this.model.get("pages");i++)
        {
            sPages.push(new Backbone.Ribs.Model({
                id:i,
                active:this.model.get("page")==i,
                name:i+1
            }));
        }*/
        /*this.pages.on("add reset remove",_.bind(this.updatePagesDisplay,this));
        this.pages.reset(sPages);*/
        this.updatePagesDisplay();
    },
    setPage:function(p)
    {
        this.model.set("isFirst",p==0);
        this.model.set("isLast",p==parseInt(this.model.get("pages"))-1);
        this.model.set("page",parseInt(p));
       /* _.each(this.pages.models,function(model){
            model.set("active",p==model.get("id"));
        });*/
        //update filter
        this.dataTable.trigger("setPage",p);
        this.updatePagesDisplay();
    },
    updatePagesDisplay:function()
    {
        var tmp=[];
        var delta=3;
        var left=parseInt(this.model.get("page"))+1-delta;
        var right=parseInt(this.model.get("page"))+1+delta;
        var i=0,l=0;
        for(i=1;i<=this.model.get("pages");i++)
        {
            if(i==1 || i==this.model.get("pages") || i>=left && i<=right)
                tmp.push(new Backbone.Ribs.Model({
                    id:i-1,
                    active:this.model.get("page")==i-1,
                    name:i
                }));
        }
        var tmpWithDots=[];
        for(i=0;i<tmp.length;i++)
        {
            if(l)
            {
                if(Math.abs(tmp[i].get("name")-l) >2)
                {
                    tmpWithDots.push(new Backbone.Ribs.Model({dots:true}));
                }
            }
            tmpWithDots.push(tmp[i]);
            l=+tmp[i].get("name");
        }
        this.pagesDisplay.reset(tmpWithDots);
    },
    onPrev:function()
    {
        if(this.model.get("page")>0)
            this.setPage(+this.model.get("page")-1);
        return false;
    },
    onNext:function()
    {
        if(this.model.get("page")!=this.model.get("pages")-1)
            this.setPage(+this.model.get("page")+1);
        return false;
    }
});

var TableItselfTh=Backbone.Ribs.View.extend({
    tagName:'th',
    bindings:{
        el:{
            text:'model.name',
            mod:{
                'fig':{
                    data:['model.allow_sort','model.sorting'],
                    processor:function(as,s)
                    {
                        return as?(Math.abs(s)?((s<0)?' sorting_desc':' sorting_asc'):' sorting'):'';
                    }
                }
            }
        }
    },
    events:{
        "click":"onClick"
    },
    onClick:function()
    {
        if(!this.model.get("allow_sort"))
            return;
        var mySorting=+this.model.get("sorting");
        _.each(this.model.collection.models,function(model){
            model.set("sorting",0);
        });

        this.model.set("sorting",Math.abs(mySorting)?((mySorting==-1)?1:-1):1);
        var why =this.model.get("bind");
        if(_.isObject(why))
            why=why.html;

        console.log(why,mySorting,Math.abs(mySorting)?((mySorting==-1)?1:-1):1);

        this.model.collection.trigger("ChangeOrder",why+":"+(Math.abs(mySorting)?((mySorting==-1)?0:1):0));
    }
});

var TableItselfTd=Backbone.Ribs.View.extend({
    tagName:'td',
    events:{
        "click":"onClick"
    },
    initialize:function(options)
    {
        //console.log("TETS",this.model.collection.customSort);
        if(options.rowclick) {

        }
        this.data=options.data;
        //what type inside of data.
        this.render();
        this.model.on("change",_.bind(this.render,this));

    },
    render:function()
    {
        var bind=this.model.get("bind");
        if(!_.isObject(bind))
        {
            this.$el.text(this.data.has(bind)?this.data.get(bind):'-');
        }else{
            this.$el.html(this.data.get(bind.html));
            this.$el.find('.ajax-publish-form').submit(AjaxPublishForm);
            this.$el.find('.ajax-unpublish-form').submit(AjaxUnpublishForm);
            this.$el.find('.ajax-delete-form').submit(AjaxDeleteForm);
            this.$el.find('[data-popover="popover"]').popover();
            if(this.model == this.collection.last() && this.collection.customSort) {
                this.$el.append("<span class='drag'></span>")
            }
        }
    },
    onClick:function(){
    //    alert("EEE",this.model.collection.rowclick);
    }
});

var TableItselfTrs=Backbone.Ribs.View.extend({
    tagName:'tr',
    bindings:{
        el:{
            collection:{
                view:null,
                col:'columns'
            }
        }
    },
    events:{
        "click":"onRowClick"
    },
    columns:null,
    initialize:function()
    {
        if(this.model.collection.rowclick && this.model.has(this.model.collection.rowclick)) {
            this.$el.addClass("has-row-click");
            this.events={
                "click":"onRowClick"
            };
        }
        var $self=this;
        this.bindings.el.collection.view=function(options){
            return new TableItselfTd(_.extend(options,{data:$self.model}));
        };
        this.columns=this.model.collection.columns;
    },
    onRowClick:function() {
        if(this.model.collection.rowclick && this.model.has(this.model.collection.rowclick)) {
            window.location = this.model.get(this.model.collection.rowclick);
            return false;
        }
        return true;
    }
});

var TableTemplateTrs=Backbone.Ribs.View.extend({
    tagName:'tr',
    initialize:function()
    {
        if(this.model.collection.rowclick && this.model.has(this.model.collection.rowclick)) {
            this.$el.addClass("has-row-click");
            this.events={
                "click":"onRowClick"
            };
        }
        this.model.on("change",_.bind(this.render));
        this.settings=this.model.collection.settings;
        this.template=Template7.compile(window.templates[this.settings.get("template")]);
        this.render();
    },
    render:function()
    {
        this.$el.html(this.template(this.model.attributes));
    },
    onRowClick:function() {
        window.location=this.model.get(this.model.collection.rowclick);
        return false;
    }
});

var TableItself=Backbone.Ribs.View.extend({
    tagName:'div',
    className:'tab-pane fade',// active in
    sorting:false,
    bindings:{
        'thead':{
            collection:{
                col:'columns',
                view:TableItselfTh
            }
        },
        'tfoot':{
            collection:{
                col:'columns',
                view:TableItselfTh
            }
        },
        'tbody':{
            collection:{
                col:'tableData',
                view:TableItselfTrs
            },
            classes:{
                'sort-avail':{
                    data:'model.customSort'
                }
            }
        },
        '.table-loading':{
            toggle:'model.loading'
        },
        '.has-no-table-data':{
            toggle:{data:['model.loading','model.length'],processor:function(a,b){ return a?false:!b }},
            text:'model.lang.nodata'
        },
        'table':{
            toggle:{
                data:['model.loading','model.length'],
                processor:function(a,b){
                    return a?false:!!b;
                }
            }
        }
    },
    filters:{
        page:0
    },
    filtersEx:{},
    prev:{abort:function(){}},
    onload:function(){},
    initialize:function(option)
    {
        this.updateFilters=_.debounce(_.bind(this.updateFiltersEx,this),300);
        console.log(option);
        if(this.model.has("onload") && this.model.get("onload").length){
            console.log(this.model.get("onload"));
            this.onload=eval(this.model.get("onload"));
        }
        this.model.set("customSort",true);
        this.$el.html(TableTempaltes['display-table-tab']);
        GlobalManager.on("reload",_.bind(function(){
            this.tableData.fetch();
        },this));
        this.columns=new Backbone.Ribs.Collection();
        this.columns.on("ChangeOrder",_.bind(this.onChangeOrder,this));

        this.columns.customSort = this.model.get("customSort",false);
        this.tableData=new TableLoaderCollection();
        this.tableData.columns=this.columns;
        this.tableData.settings=this.model;
        if(this.tableData.settings.has("baseUrl")) {
            this.tableData.baseUrl = this.tableData.settings.get("baseUrl");
        }
        GlobalManager.on("ajax_change_url",function(baseUrl) {
            this.tableData.baseUrl = baseUrl;
            this.tableData.fetch();
        }.bind(this));
        this.tableData.on("setPage",_.bind(this.setPage,this));
        this.tableData.on("availSort",_.bind(this.setSorting,this));
        this.tableData.on("changeCustomSorting",_.bind(function(sort){
            this.model.set("customSort",sort);
            this.columns.customSort = sort;
            //this.$el.find('tbody').sortable( "refresh" );
        },this));
        this.filters=this.model.has("filters")?this.model.get("filters"):{};
        _.extend(this.filters,this.model.collection.tableFilterNow);
        this.tableData.filters=this.filters;
        if(!this.model.has("lang.nodata"))
            this.model.set("lang.nodata","No Data");

        var first=1;
        _.each(this.model.get("columns"),_.bind(function(column,key){

            var m=new Backbone.Ribs.Model({
                name:key,
                bind:column,
                allow_sort:!_.isObject(column) || !!column.allowsort,
                sorting:first?first--:0
            });
            this.columns.add(m);
        },this));

        if(this.model.has("rowclick")) {
            var click=this.model.get("rowclick");
            if(click.length) {
                this.tableData.rowclick=click;
            }
        }else{
            this.tableData.rowclick=null;
        }

        if(this.model.has("template"))
        {
            this.bindings.tbody.collection.view=TableTemplateTrs;
        }
        this.model.on("change:active",_.bind(this.changeVisible,this));
        this.model.set("loading",true);
        this.model.set("length",0);
        this.tableData.on("add remove reset",_.bind(function(){
            this.model.set("length",this.tableData.rlength);
            setTimeout(_.bind(function(){
                this.onload();
                //this.$el.find('tbody').sortable( "refresh" );
                console.log("update sorting");
            },this),300);
        },this));

       /* this.tableData.fetch({success:_.bind(function(){
            this.model.set("loading",false);
            this.model.set("length",this.tableData.rlength);
            console.log("complete loading");
        },this)});*/
        _.extend(window.GLANG,this.model.get("lang"));
        this.changeVisible();
        this.paginator=new TablePaginator({tableData:this.tableData,lang:this.model.get("lang")});
        this.$el.append(this.paginator.el);
        this.model.collection.on("FilterChange",_.bind(this.onFilterChange,this));
        this.model.collection.on('onFilterEx',_.bind(this.onFilterEx,this));
        this.model.collection.on('onChangeColumns',_.bind(this.onColumnsChange,this));
        this.updateFilters();



        var adjustment = 0;
        var oldIndex = 0;
        if(this.model.get("customSort",false)) {
            _.defer(function () {

                $(this.$el.find("tbody")[0]).sortable({
                    helper: function (e, tr) {
                        console.log("TEST");
                        var $originals = tr.children();
                        var $helper = tr.clone();
                        $helper.children().each(function (index) {
                            $(this).width($originals.eq(index).width())
                        });
                        return $helper;
                    },
                    beforeStop: function (event, ui) {
                        console.log(arguments);
                    },
                    //  stop: updateIndex,
                    handle: "td:last-child .drag",
                    itemSelector: 'tr',
                    placeholder: '<tr class="placeholder"></tr>',
                    onDrop: function ($item, container, _super) {
                        $("body").removeClass("dragging");
                        if ($item.index() !== oldIndex) {
                            $item.removeClass("dragged").removeAttr("style");
                            $item.children().each(function () {
                                $(this).removeAttr("style")
                            });
                            var modal = new ModalWrapper({
                                content: TableMagickCancelSortModal,
                                title: window.LANGUAGE['tablemagick.sort.modal.title'],
                                config: {
                                    controller: this,
                                    doCancel: function () {
                                        if (oldIndex < $item.index()) {
                                            $item.parent().children().eq(oldIndex).before($item);
                                        } else {
                                            $item.parent().children().eq(oldIndex).after($item);
                                        }
                                        // $clonedItem.detach();

                                    }.bind(this),
                                    doApply: function () {
                                        $item.removeClass("dragged").removeAttr("style");
                                        $item.children().each(function () {
                                            $(this).removeAttr("style")
                                        });
                                        var ids = [];
                                        $item.parent().find("input[name=id]").each(function (a, b) {
                                            ids.push($(b).attr("value"));
                                        });
                                        this.tableData.updateSorting(ids);
                                    }.bind(this)
                                }
                            });
                            modal.show();
                        }else{
                            $item.removeClass("dragged").removeAttr("style");
                            $item.children().each(function () {
                                $(this).removeAttr("style")
                            });
                        }
                    }.bind(this),
                    onDragStart: function ($item, container, _super) {
                        var offset = $item.offset(),
                            pointer = container.rootGroup.pointer;
                        container.rootGroup.placeholder.html($item.html());
                        _.defer(function () {
                            var $originals = container.rootGroup.placeholder.children();
                            $item.children().each(function (index) {
                                $(this).width($originals.eq(index).width())
                            });
                        }.bind(this));

                        adjustment = pointer.top - offset.top;
                        oldIndex = $item.index();
                        $item.appendTo($item.parent());
                        _super($item, container);
                    },
                    onDrag: function ($item, position, _super) {
                        position.left = 0;
                        position.top -= adjustment;

                        _super($item, position);
                    }
                }).disableSelection();

                /* this.$el.find("tbody").sortable({
                     distance: 5,
                     delay: 100,
                     opacity: 0.6,
                     cursor: 'move',
                     update: function() {}
                 });*/
            }.bind(this));
        }


    },
    onFilterEx:function(filters) {
        this.filtersEx = filters;
        this.updateFilters();
    },
    onColumnsChange: function(columns) {
        this.columns.reset(columns);
    },
    changeVisible:function()
    {
        var $el=this.$el;
        if(this.model.get("active"))
        {
            _.delay(function(){
                $el.removeClass("out").addClass("active");
                _.delay(function(){
                    $el.addClass("in");
                },0);
            },300);
        }else{
            $el.removeClass("in").addClass("out");
            _.delay(function(){
                $el.removeClass("active")
            },300);
        }
    },
    onChangeOrder:function(why)
    {
        this.filters.orderby=why;
        this.updateFilters();
    },
    updateFiltersEx:function()
    {
        this.tableData.filters=_.extend({}, this.filters, this.filtersEx);
        console.log("Filters reload",this.tableData.filters);
        this.prev.abort();
        this.model.set("loading",true);
        this.prev=this.tableData.fetch({
            success:_.bind(function(){
                this.model.set("loading",false);
            },this)
        });
    },
    setPage:function(page)
    {
        if(this.filters.page!=page) {
            this.filters.page = page;
            this.updateFilters();
        }
    },
    onFilterChange:function(filter)
    {
        if(!filter || !filter.complete)
            return false;

        if(filter.value===null)
        {
            this.filters=_.omit(this.filters,[filter.name]);
        }else{
            this.filters[filter.name]=filter.value;
            this.filters.page=0;
        }
        this.updateFilters();
    },
    setSorting:function(sort)
    {
        _.each(this.columns.models,function(model){
            model.set("sorting",0);
        });

        _.each(this.columns.models,function(model){
            _.each(sort,function(s){
                var t=model.get("bind");
                if(_.isObject(t))
                    t=t.html;
                if(t===s[0])
                {
                    model.set("sorting",(s[1]==="ASC")?1:-1);
                }
            });
        });
    }
});

var TableTabLi=Backbone.Ribs.View.extend({
    tagName:'li',
    bindings:{
        el:{
            classes:{
                active:'model.active'
            }
        },
        a:{
            text:{
                data:['model.name','model.length'],
                processor: function(name, length) {
                    var res = name;
                    if(length) {
                        res+= ' ('+length+')';
                    }
                    return res;
                }
            }
        }
    },
    events:{
        "click":"onSelect"
    },
    initialize:function(options)
    {

        this.$el.html('<a href="#"></a>');
    },
    onSelect:function()
    {
        _.each(this.collection.models,function(c){c.set("active",false)});
        this.model.set("active",true);
        window.location.hash=this.model.get("id");
        return false;
    }
});

var TableDisplay=Backbone.Ribs.View.extend({
    bindings:{
        '.table-magick-content':{
            collection:{
                col:'collection',
                view:TableItself
            }
        },
        '.toples-header-tab-nav':{
            collection:{
                col:'collection',
                view:TableTabLi
            },
            toggle:{
                data:'model.colLength',
                processor:function(val) {
                    return val>1;
                }
            }
        },
        '.table-magick-header ':{
            toggle:{data:'model.colLength',
                processor:function(a){ return a>1;}}
        }
    },
    tabs:[],
    columns:[],
    initialize:function(options)
    {
        var map=['released','design','tab3','tab4'];
        this.tableFilters=options.tabFilters;
        this.model=new Backbone.Ribs.Model({colLength:0});
        this.$el.html('<div class="table-magick-header card-body card-padding"></div><ul class="tab-nav toples-header-tab-nav"></ul><div class="table-magick-content tab-content clearfix"></div>');
        this.collection.on("add reset remove",_.bind(this.onLength,this));
        this.tableFilters.col.on("FilterChange",_.bind(function(filter){
            this.collection.trigger("FilterChange",filter);
        },this));
        this.collection.tableFilterNow={};
        _.each(this.tableFilters.col.models,_.bind(function(model){
            if(model.get("value")!=null)
                this.collection.tableFilterNow[model.get('name')]=model.get("value");
        },this));
        this.collection.map(function(k,i){ k.set("id",map[i]); });
        this.collection.length?this.collection.at(0).set("active",true):'';
        if(window.location.hash.length>2) {
            if(this.collection.where({id:window.location.hash.substr(1)}).length) {
                this.collection.map(function(i){i.set("active",false);});
                this.collection.where({id:window.location.hash.substr(1)}).map(function(item){ item.set("active",true)});
            }

        }

        GlobalManager.on("to-design",_.bind(function(){
            if(this.collection.where({id:'design'}).length) {
                this.collection.map(function(i){i.set("active",false);});
                this.collection.where({id:'design'}).map(function(item){ item.set("active",true)});
                window.location.hash='design';
            }
        },this));

        GlobalManager.on("to-released",_.bind(function(){
            if(this.collection.where({id:'released'}).length) {
                this.collection.map(function(i){i.set("active",false);});
                this.collection.where({id:'released'}).map(function(item){ item.set("active",true)});
                window.location.hash='released';
            }
        },this));

        this.onLength();
    },
    onLength:function()
    {
        this.model.set("colLength",this.collection.length);
    },
    reload:function()
    {
        this.collection.trigger("ReloadMe");
    },
    exFilters:function(filters) {
        //this.tableDisplay.exFilters(filters);
    }
});

var TableMagick=Backbone.Ribs.View.extend({
    className:'table-responsive',
    bindings:{
    },
    filter:null,
    initialize:function(options){
        this.$el.addClass(this.className);
        this.model=new Backbone.Ribs.Model({
            tables:[]
        });

        try {
            this.collection=new Backbone.Ribs.Collection();
            var jsonAr=JSON.parse(this.$el.attr("table-magick"));
            _.each(jsonAr,_.bind(function(ar){
                this.collection.add(new Backbone.Ribs.Model(ar));
            },this));

        }catch (e){

        }

        this.$el.html(TableTempaltes.table);
        this.$tableWrapper=$(this.$el.find(".dataTables_wrapper")[0]);
        this.tableFilters=new TableFilters({});
        this.tableDisplay=new TableDisplay({collection:this.collection,tabFilters:this.tableFilters});
        this.$tableWrapper.append(this.tableFilters.el);
        this.$tableWrapper.append(this.tableDisplay.el);
    },
    reload:function()
    {
        this.tableDisplay.reload();
    },
    exFilters:function(filters) {
        console.log("Ex-filter-call",filters);
        this.collection.trigger('onFilterEx',filters);
    },
    exColumns: function(columns) {
        this.collection.trigger('onChangeColumns',columns);
    }
});


$(function(){

    $('[table-magick]').each(function(i,el){
        el.magick=new TableMagick({el:el});
    });


});